// extracted by mini-css-extract-plugin
export default {"typeIcon":"styles_typeIcon__Ehfd6","emailType":"styles_emailType__Qmm0g","actionsPopover":"styles_actionsPopover__mUobp","bringg-icon":"styles_bringg-icon__9fako"};